import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

export interface SchemaAgentDraftNoticeProps {
  onOpenReview: () => void
  onBack: () => void
}

/** Banner above the read-only draft the schema agent proposed. */
export function SchemaAgentDraftNotice({ onOpenReview, onBack }: SchemaAgentDraftNoticeProps) {
  const { t } = useTranslation()
  return (
    <div className="flex max-md:flex-wrap items-center gap-3 rounded-lg border border-primary/30 bg-primary/5 p-4">
      <Sparkles className="size-5 shrink-0 text-primary" />
      <p className="max-md:min-w-48 flex-1 text-sm text-foreground">
        {t('schemaAgent.draftNotice')}
      </p>
      <Button variant="outline" size="sm" onClick={onBack} className="shrink-0 border-border">
        {t('schemaAgent.review.hideDraft')}
      </Button>
      <Button size="sm" onClick={onOpenReview} className="shrink-0">
        {t('schemaAgent.review.open')}
      </Button>
    </div>
  )
}
